import { forwardRef } from 'react'

import { Textarea, TextareaProps } from '@mantine/core'

const ApplicationTextareaInput = forwardRef<
  HTMLTextAreaElement,
  TextareaProps
>((props, ref) => {
  const labelStyles = 'text-sm text-doubleNickel-gray-600 font-medium'
  const wrapperStyles = 'border-b-[1px] border-doubleNickel-gray-300'
  const inputStyles = `text-base font-medium`
  const rootStyles = `w-full`

  return (
    <Textarea
      ref={ref}
      variant={'unstyled'}
      classNames={{
        label: labelStyles,
        wrapper: wrapperStyles,
        input: inputStyles,
      }}
      className={rootStyles}
      minRows={3}
      {...props}
    />
  )
})

export default ApplicationTextareaInput
